// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/separator.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "habit-streak-app")
// Destination      : packages/fleet/ui/src/separator.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo habit-streak-app
//     node fleet/fleet.ts check --repo habit-streak-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { type Component, splitProps } from "solid-js";
import { cn } from "@habits/shared";

type SeparatorProps = {
  class?: string;
  orientation?: "horizontal" | "vertical";
};

const Separator: Component<SeparatorProps> = (props) => {
  const [local, rest] = splitProps(props, ["class", "orientation"]);
  return (
    <div
      role="separator"
      aria-orientation={local.orientation ?? "horizontal"}
      class={cn(
        "shrink-0 bg-accent/20",
        local.orientation === "vertical" ? "h-full w-px" : "h-px w-full",
        local.class,
      )}
      {...rest}
    />
  );
};

export { Separator };
